import { useState, useEffect } from "react";
import { useData } from "./DataContext.js";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";

import NavbarLogo from "./NavbarLogo.js";
import GroupLoginModal from "./GroupLoginModal.js";
import AdminPanel from "./AdminPanel.js";

export default function PlayNavbar (props)
{
    const gData = useData();

    // LOGIN MODAL
    const [login, setLogin] = useState(true);
    function showLogin () { setLogin(true); }
    function hideLogin () { setLogin(false); }

    useEffect(() => { if (gData.simID !== null) hideLogin(); else showLogin(); }, [gData.simID]);

    // ADMIN PANEL
    const [adminPanel, setAdminPanel] = useState(false);
    function showAdminPanel () { setAdminPanel(true); }
    function hideAdminPanel () { setAdminPanel(false); }
    
    const sim = (gData.simID !== null && gData.sim[gData.simID] !== undefined) ?
		gData.sim[gData.simID] : null;

    const group = (gData.groupID !== null && gData.group[gData.groupID] !== undefined) ?
		  gData.group[gData.groupID] : null;

    return (
	<>
	    <Navbar expand="lg" className="bg-body-tertiary">
		<Container className="d-flex align-items-center">
		    <NavbarLogo/>
		    {sim !== null && (<Navbar.Text className="ms-3 my-0 fs-4">{sim.title} / {group.title}</Navbar.Text>)}
		    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
		    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
			{gData.admin && (<div className="d-flex gap-2"><Button variant="primary" size="md" onClick={showAdminPanel}>Panneau d'administration</Button></div>)}
		    </Navbar.Collapse>
		</Container>
	    </Navbar>
	    {gData.admin && (<AdminPanel show={adminPanel} hide={hideAdminPanel}/>)}
	    <GroupLoginModal show={login} submit={props.submitLogin} code={props.code}/>
	</>
    );
}
